// extracted by mini-css-extract-plugin
export var label = "_cp-1";
export var reminder = "_cp-0";